import React from 'react';
import { Dialog, TextField, Checkbox, Button } from "@vitalsource/vstui";
import { toastUtils } from "../../utils/toast-utils";
import Dispatcher from "../../dispatcher";

const styles = {
  checkbox: {
    marginTop: '5px',
  },
  survey: {
    marginTop: "15px",
  },
};

class FeedbackForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contactMe: true,
    };
    this._onChangeContactMe = this._onChangeContactMe.bind(this);
    this._closeModal = this._closeModal.bind(this);
    this._feedbackOnSubmit = this._feedbackOnSubmit.bind(this);
  }

  _closeModal() {
    this.props.onClose 
      ? this.props.onClose() 
      : Dispatcher.emit(Dispatcher.CLOSE_MODAL);
  }	  

  _onChangeContactMe() {
    this.setState(state => {
      return {contactMe: !state.contactMe};
    });
  }

  renderSurvey() {
    if (Fraction.Brand.Feedback.survey) {
      return (
        <div style={styles.survey}>
          {i18n.tsx(
            'messages.feedback-survey',
            {
              link: <Button
                inline
                naked
                target="_blank" 
                title={i18n.t('messages.fill-out-survey')}
              >
                {i18n.t('messages.fill-out-survey')}
              </Button>
          })}
        </div>
      );
    }
  }

  _feedbackOnSubmit(e) {
    e.preventDefault();
    $.ajax({
      url: "https://docs.google.com/forms/d/1gFrTyvLndaZZg60Vag_Cy8AzEvvqRVHN0W3eXuZBXfk/formResponse",
      type: "POST",
      data: {
        "entry.1804158828": this.feedBack.value, // user entry
        "entry.1369683036": (Fraction.User ? Fraction.User.email.hashMe() : ""), // user email
        "entry.1358226092": brands.brand_name, // brand
        "entry.1777263903": Fraction.currentISBN, // vbid
        "entry.597531617" : navigator.userAgent, // user agent
        "entry.494128414" : $(window).width(),
        "entry.1078903955": (this.checkBox.checked ? "Yes" : "")
      },
    });
    this._closeModal();
    toastUtils.notify(
      i18n.t('messages.feedback-thanks'),
      { type: "success" }
    );
  }

  render() {
    return (
      <Dialog
        closeButtonLabel={i18n.t('base.close')}
        open
        formProps={{ onSubmit: this._feedbackOnSubmit }}
        primaryActionButton={{ label: i18n.t('base.submit') }}
        secondaryActionButton={{
          label: i18n.t('base.cancel'),
          onClick: this._closeModal,
        }}
        onRequestClose={this._closeModal}
        size="small"
        rootSelector="#bookshelf"
        title={i18n.t('messages.feedback-title')}
      >
        <div className="general-feedback-survey">
          <TextField
            label={i18n.t('global-bar.feedback')}
            labelHidden
            fullWidth
            multiline
            rows={2}
            required
            name="give-feedback"
            placeholder={i18n.t('messages.feedback-enter-feedback')}
            nativeFormControlRef={x => (this.feedBack = x)}
          />
          <div className="checkbox-text" style={styles.checkbox}>
            <Checkbox
              label={i18n.t('messages.feedback-followup')}
              data-key="contactMe"
              onChange={this._onChangeContactMe}
              checked={this.state.contactMe}
              nativeFormControlRef={x => (this.checkBox = x)}
            />
          </div>

          {this.renderSurvey()}
        </div>
      </Dialog>
    );
  }
}
module.exports = FeedbackForm;
